/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:20:04
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 16:10:54
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/SearchInput/index.tsx
 */
import Search from '@/src/components/Antd/Search/Search';
import { SearchOutlined } from '@ant-design/icons';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const SearchInput = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [input, setInput] = React.useState('');
  const {
    onPress,
    onSearch,
    searchInputClassName,
    existingData = [],
    placeholder,
  } = props;
  const checkDuplicate = (text) => {
    return !!existingData.find((i) => i.label === text);
  };
  const emptyInput = () => {
    setInput('');
  };
  const handleInputChange = (value) => {
    setInput((value || '').trim());
  };
  const getSearchText = () => input.trim();
  const handleOnPress = () => {
    const searchText = getSearchText();
    if (onPress && searchText) {
      if (!checkDuplicate(searchText)) {
        onPress({ value: searchText, label: searchText });
      }
    }
    emptyInput();
  };

  const handleOnSearch = () => {
    const searchText = getSearchText();
    if (onPress && searchText) {
      if (!checkDuplicate(searchText)) {
        onSearch({ value: searchText, label: searchText });
      }
    }
    emptyInput();
  };
  return (
    <Search
      maxLength={30}
      className={`${css.searchInput} ${searchInputClassName || ''}`}
      placeholder={placeholder || getI18n('general.filterGroup.search')}
      allowClear
      enterButton={getI18n('general.filterGroup.search')}
      prefix={<SearchOutlined />}
      onPressEnter={handleOnPress}
      onChange={handleInputChange}
      value={input}
      onSearch={handleOnSearch}
    />
  );
};
export default SearchInput;
